<div class="sidebar">
  <ul class="uk-padding-remove uk-margin-remove sidebar-content">
    <li class="uk-grid uk-grid-small uk-grid-collapse sidebar-menu-item" *ngFor="let item of menu"
      [routerLink]= "item.routerLink"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ exact: item.routerLink === '/' }">
      <div class="menu-item-icon" style="width: 36px">
        <ng-container *ngIf="item.badgeNumber; else displayIcon">
          <div [ngClass]="{'menu-item-icon-badge': item.badgeNumber > 0}" [attr.data-badge]="item.badgeNumber">
            <i class="material-icons">
              {{item.icon}}
            </i>
          </div>
        </ng-container>
        <ng-template #displayIcon>
          <i class="material-icons">
            {{item.icon}}
          </i>
        </ng-template>
      </div>
      <div id="libelle" class="uk-width-expand uk-visible@m uk-padding-remove menu-item-text" *ngIf="!isInternetExplorer">
        {{item.libelle}}
      </div>
    </li>
    <div class="sidebar-end-button uk-visible@m" [ngClass]="{'uk-invisible': isInternetExplorer}">
      <button kendoButton
        class="sidebar-toggle-button k-button k-primary"
        uk-toggle="target: #libelle; animation: uk-animation-slide-left-small"
        (click)="toggleSidebar()"
        [svgIcon]="svgFilterClear"
        title="Supprimer les filtres">
    </button>
    </div>
  </ul>
</div>
